import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Alert,
  Box,
  Button,
  Container,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import api from "../Utility/api";
import { useAuth } from "../Utility/AuthContext";
const API = process.env.REACT_APP_API_URL || "";
export default function Login() {
  const { user, setUser, loading } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from;
  const destination =
    typeof from === "string" && from.startsWith("/") && !from.startsWith("//")
      ? from
      : "/dashboard";
  useEffect(() => {
    if (user) navigate(destination, { replace: true });
  }, [user, navigate, destination]);
  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post(`${API}/api/login`, {
        username: username.trim(),
        password,
      });
      // Confirm the browser kept the cookie before claiming login succeeded.
      try {
        const { data } = await api.get(`${API}/api/me`);
        setUser(data.user);
      } catch {
        setError(
          "Your browser could not keep you signed in. Open this site directly in your browser, allow cookies for this site, and try again. If this continues, contact the site owner.",
        );
      }
    } catch (err) {
      setError(
        err.response?.data?.error ||
          "Unable to sign in. Check your connection and try again.",
      );
    } finally {
      setBusy(false);
    }
  };
  return (
    <Container maxWidth="xs" sx={{ pt: { xs: 5, sm: 9 } }}>
      <Paper sx={{ p: { xs: 3, sm: 4 } }} elevation={6}>
        <span className="eyebrow">Your next chapter awaits</span>
        <Typography variant="h4" component="h1" mb={1}>
          Welcome back.
        </Typography>
        <Typography color="text.secondary" mb={3}>
          Pick up where your imagination left off.
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <Box component="form" onSubmit={submit}>
          <Stack gap={2.5}>
            <TextField
              label="Username"
              name="username"
              autoComplete="username"
              inputProps={{
                autoCapitalize: "none",
                autoCorrect: "off",
                spellCheck: false,
              }}
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              required
              fullWidth
            />
            <TextField
              label="Password"
              name="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
              fullWidth
            />
            <Button
              type="submit"
              variant="contained"
              size="large"
              disabled={busy || loading}
            >
              {busy ? "Signing in…" : "Sign in"}
            </Button>
          </Stack>
        </Box>
        <Typography mt={3} variant="body2">
          New to the story? <Link to="/register">Create an account</Link>
        </Typography>
        <Typography mt={2} variant="body2">
          <Link to="/forgotpassword">Forgot your password?</Link>
        </Typography>
      </Paper>
    </Container>
  );
}
